import type { TocBlockConfig } from '@lighthouse/core'

export const generateTocBlock = (mainBreakPoint: string): TocBlockConfig => {
    return {
        targetBlockId: '',
        maxDepth: 3,
        offsetY: 0,
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 200,
                    unit: 'px'
                },
                height: {
                    size: 'fill'
                }
            }
        },
        breakPoints: []
    }
}
